import React from 'react';
import { BookHero } from '../components/BookHero';
import { SalesLetter } from '../components/SalesLetter';
import { CTASection } from '../components/CTASection';
import { CountdownTimer } from '../components/CountdownTimer';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ProductOffersSection } from '../components/ProductOffersSection';
import { SalesPopup } from '../components/SalesPopup';
import { motion, useScroll, useSpring } from 'framer-motion';
export function LandingPage() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="min-h-screen bg-[#F9F7F1] selection:bg-[#7F1D1D] selection:text-white" data-id="element-444">
      {/* Reading Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-[#7F1D1D] origin-left z-50" style={{
      scaleX
    }} data-id="element-445" />

      <CountdownTimer data-id="element-446" />
      <SalesPopup data-id="element-447" />

      <main className="relative" data-id="element-448">
        <BookHero data-id="element-449" />
        <SalesLetter data-id="element-450" />
        <TestimonialsSection data-id="element-451" />
        <ProductOffersSection data-id="element-452" />
        <CTASection data-id="element-453" />
      </main>

      <footer className="bg-white text-[#1C1917] py-12 text-center text-sm font-sans border-t border-[#E7E5E4]" data-id="element-454">
        <p data-id="element-455">
          &copy; {new Date().getFullYear()} Minerales de Sangre. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}